import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=551e268b&"
import script from "./manifest.vue?vue&type=script&lang=js&"
export * from "./manifest.vue?vue&type=script&lang=js&"
import style0 from "./manifest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports